import { CommonModule } from '@angular/common';
import { Component, computed, model, Signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TranslationModule } from '../../../../i18n/translation-module';
import { CrmFieldService, StandardIds } from '../../../../shared-services/crm-services/field.service';
import { ActivityInterface } from '@vendasta/crm';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';

import { ActivityRichTextComponent } from '../../activities/activity-rich-text.component';

@Component({
  selector: 'crm-activity-logged-communication-v2',
  templateUrl: './logged-communication-v2.component.html',
  styleUrls: ['./logged-communication-v2.component.scss'],
  providers: [],
  imports: [CommonModule, TranslateModule, TranslationModule, GalaxyPipesModule, ActivityRichTextComponent],
})
export class CrmActivityLoggedCommunicationV2Component {
  activity = model<ActivityInterface>({});

  cardInfo: Signal<ActivityCardInformation> = computed(() => {
    return {
      body: this.getStringFieldData(this.activity(), StandardIds.ActivityCommunicationBody),
      activityUrl: this.getStringFieldData(this.activity(), StandardIds.ActivityUrl),
      activityUrlName: this.getStringFieldData(this.activity(), StandardIds.ActivityUrlName),
      outcome: this.getStringFieldData(this.activity(), StandardIds.ActivityCommunicationOutcome),
    };
  });

  private getStringFieldData(activity: ActivityInterface, fieldId: string): string {
    return this.fieldService.getFieldValueFromCrmObject(activity, fieldId)?.stringValue ?? '';
  }

  constructor(private readonly fieldService: CrmFieldService) {}
}

interface ActivityCardInformation {
  body: string;
  activityUrl?: string;
  activityUrlName: string;
  outcome: string;
}
